import { MediaListItemDesktop } from "../Molecules/MediaListItemDesktop";
import { TaskLinks } from "../types/taskLink";
import {
  AlertResponse,
  Media,
  MediaResponse,
  MediasResponse,
} from "../types/media";
import { MediaListItemSkeletonDesktop } from "../Molecules/MediaListItemSkeletonDesktop";
import { MediaListDesktop } from "../styles/styles";

interface MediasViewListDesktopProps {
  mediasResponse: MediasResponse | undefined;
  alerts: AlertResponse[] | undefined;
  taskLinks: TaskLinks;
  onSaveMedia: (media: Media) => void;
  loading?: boolean;
}
export function MediasViewListDesktop({
  mediasResponse,
  alerts,
  taskLinks,
  onSaveMedia,
  loading,
}: MediasViewListDesktopProps) {
  if (loading) {
    return (
      <MediaListDesktop id="media-view-list">
        <MediaListItemSkeletonDesktop key="medias-view-list-0" />
        <MediaListItemSkeletonDesktop key="medias-view-list-1" />
        <MediaListItemSkeletonDesktop key="medias-view-list-2" />
        <MediaListItemSkeletonDesktop key="medias-view-list-3" />
        <MediaListItemSkeletonDesktop key="medias-view-list-4" />
        <MediaListItemSkeletonDesktop key="medias-view-list-5" />
        <MediaListItemSkeletonDesktop key="medias-view-list-6" />
        <MediaListItemSkeletonDesktop key="medias-view-list-7" />
      </MediaListDesktop>
    );
  } else {
    return (
      <MediaListDesktop id="media-view-list">
        {mediasResponse?.medias &&
          mediasResponse?.medias.map((media, idx) => (
            <MediaListItemDesktop
              key={`medias-view-list-${idx + 1}`}
              mediaResponse={
                {
                  media: media,
                  children: mediasResponse?.children ?? [],
                } as MediaResponse
              }
              alert={alerts?.find(({ mediaId }) => mediaId === media.id)}
              tasks={taskLinks.filter(({ mediaId }) => mediaId === media.id)}
              onSaveMedia={onSaveMedia}
            />
          ))}
      </MediaListDesktop>
    );
  }
}
